import { makeAutoObservable } from "mobx";
import React from "react";
import { loadAttrTypeMap } from "src/common/attributes";
import { onError } from "src/common/onError";
import {
  makeAttrLabel,
  MakeLabelMode,
} from "src/common/attributes/makeAttrLabel/makeAttrLabel";
import { getAllLabelDataAttributes } from "src/common/attributes/makeAttrLabel/utils/getAllLabelDataAttributes";
import { getAttrLabelTreeData } from "src/common/attributes/makeAttrLabel/utils/getAttrLabelTreeData";
import { ZAttrLabelsData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";

export class AttrLinkedStore {
  constructor(
    readonly labelsData: ZAttrLabelsData,
    readonly entityId: ZUid,
    readonly attr: ZAttribute,
  ) {
    makeAutoObservable(this);
  }

  label: React.ReactNode;

  setLabel(v: React.ReactNode) {
    this.label = v;
  }

  async init() {
    try {
      this.setTypesMap(await loadAttrTypeMap());
      const labelData4Attr = getAttrLabelTreeData(
        this.attr,
        this.labelsData.labels || [],
      );
      if (!labelData4Attr) {
        this.setLabel(null);
      } else {
        const label = makeAttrLabel({
          attribute: this.attr,
          attributeList: getAllLabelDataAttributes(this.labelsData.attributes),
          labelTreeData: [labelData4Attr],
          typesMap: this.typesMap,
          mode: MakeLabelMode.entityCard,
        });
        this.setLabel(label);
      }
    } catch (error) {
      onError(error);
    }
  }

  typesMap: Record<number, string> = {};

  setTypesMap(list: Record<number, string>) {
    this.typesMap = list;
  }
}

export const createAttrLinkedStore = (
  labelsData: ZAttrLabelsData,
  entityId: ZUid,
  attr: ZAttribute,
) => {
  const store = new AttrLinkedStore(labelsData, entityId, attr);
  store.init();
  return store;
};
